import * as Highcharts from 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/boost';
import '../../highcharts-options';

import * as utils from '../../../utils';

import { Aeroval } from '../../../types/global';
declare var aeroval: Aeroval;

import { RadarPlotData } from '../../../types/data';
import { clearPopup, makePopup } from '../../popup';
import { showTooltip, hideTooltip } from '../../chart-tooltip'

// get categories from config.json
import categories from './config.json';

function radiusNormalize(value: number, which: string): number {
	let normalizedValues: number
	// translate the following python code into javascript, return r as normalizedValue
	normalizedValues = value !== null ? value : 0;
	normalizedValues = Math.abs(normalizedValues) / 2.0;

	// Correlations have 1/beta**2
	if (which.includes('1-R')) {
		normalizedValues = normalizedValues / 2.0;
	}

	return normalizedValues;
}

export function plotRadar(data: RadarPlotData | undefined, observation: string, parameterDir: string, layer: string, div: string, _chartOptions: any = {}) {
	if (!data) return;


	const keyTime = utils.getKeyTime(aeroval.time, aeroval.season);
	const models = Object.keys(data)
	const modelsStyle = aeroval.modelStyle;
	let isDataAvailable = false

	const series = [] as any;

	// add target: filled area between 0 and 1
	series.push({
		name: 'Target',
		data: Object.keys(categories).map(() => 1),
		color: '#D0D0D0',
		fillOpacity: 0.20,
		opacity: 0.5,
		type: 'area',
		marker: {
			enabled: false
		},
		showInLegend: false,
		enableMouseTracking: false,
		states: {
			hover: {
				enabled: false
			}
		}
	})

	for (let j: number = 0; j < models.length; j++) {
		const model = models[j]
		let modelData = data[model][parameterDir][observation][layer][model][aeroval.model.var][keyTime]
		if (modelData) {
			isDataAvailable = true
			// make seriesData considering categories- If the category has a dot, it means it's nested in the data object, so we need to access it accordingly
			const seriesData = Object.keys(categories).map((metric) => {
				const keys = metric.split('.')
				let value = modelData as any;
				for (const key of keys) {
					value = value[key]
				}
				return radiusNormalize(value, metric)
			})
			// model color
			const highchartsColor = utils.highchartsPalette(j);
			const modelStyle = modelsStyle[model];
			const modVisible = typeof aeroval.seriesVisibility[model] != 'undefined' ? aeroval.seriesVisibility[model] : true;
			const colorModel = modelStyle?.color ? modelStyle.color : highchartsColor;

			series.push({
				type: 'area',
				fillOpacity: 0.2,
				name: model,
				data: seriesData,
				visible: modVisible,
				color: colorModel
			})
		} else {
			console.warn(`No radar data available for model ${model} at time ${keyTime}`)
		}

	}

	if (isDataAvailable == false) {
		makePopup('alert', 'No radar plot is available for the current selection', 'warning', false);
	} else {
		clearPopup('alert')
	}


	const titleText = getTitle(parameterDir)[0];
	const subtitleText = ''

	const yAxisType = aeroval.radarType ? aeroval.radarType : 'linear';
	const yAxisMin = yAxisType === 'logarithmic' ? 1e-2 : 0;

	Highcharts.chart({
		chart: {
			polar: true,
			renderTo: div,
			spacingLeft: 0,
			height: 650
		},
		title: {
			text: titleText,
		},
		subtitle: {
			text: subtitleText,
		},
		pane: {
			startAngle: 0,
			endAngle: 360,
		},
		xAxis: {
			categories: Object.keys(categories).map(key => categories[key as keyof typeof categories].name),
		},
		yAxis: {
			min: yAxisMin,
			type: yAxisType,
		},
		tooltip: {
			useHTML: true,
			headerFormat: '',
			pointFormat: '<b>{series.name}</b><br>{point.category:%.2f}: {point.y:.2f}',
		},
		legend: {
			enabled: true,
			layout: 'horizontal',
			align: 'center',
			verticalAlign: 'bottom',
			floating: false,
			y: 10,
			x: 0,
			itemMarginBottom: 5,
			symbolWidth: 12,
			symbolHeight: 12
		},
		series
	})

	// add text decoration and tooltip to Others
	addTextDecorationAndTooltip(div)
}


function getTitle(parameterDir: string): [string, string] {
	const parameterName = aeroval.menu[parameterDir].name
	var title = `${parameterName} - ${aeroval.region} - ${aeroval.time}`;
	if (aeroval.season !== 'All') {
		title += ` (${aeroval.season})`;
	}
	const fontSize = title.length >= 40 ? '16px' : '14px';
	return [title, fontSize];
}



async function addTextDecorationAndTooltip(container: string): Promise<void> {
	const legendItems = document.querySelectorAll(`#${container} .highcharts-radial-axis-labels text`);

	legendItems.forEach(item => {
		const seriesName = item.textContent?.trim();
		if (!seriesName) return;
		// if seriesName in categories.name, add tooltip and underline
		if (Object.values(categories).some(category => category.name === seriesName)) {
			const element = item as HTMLElement;
			element.style.textDecoration = 'underline';
			const tooltipText = Object.values(categories).find(category => category.name === seriesName)?.tooltip;

			if (tooltipText) {
				element.setAttribute('data-tooltip', tooltipText);
				element.classList.add('frosted-glass');
			}
			element.addEventListener('mouseenter', showTooltip);
			element.addEventListener('mouseleave', hideTooltip);
		}

	});
}